import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.css']
})
export class ContactListComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
